// extracted by mini-css-extract-plugin
export var chip = "_b6-0";
export var filterDropdown = "_b6-5";
export var filterItem = "_b6-6";
export var icon = "_b6-1";
export var removeButton = "_b6-3";
export var removeIcon = "_b6-4";
export var separator = "_b6-2";